import i18next from 'i18next';
import React from 'react';

import * as Flags from '@deepsight/react-flags-select';

export const rowLabels = [
  {
    id: 'supplierProducts',
    label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.SUPPLIER_PRODUCTS'),
  },
  {
    id: 'supplierProductPackagings',
    label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.PACKAGINGS'),
  },
  { id: 'ingredients', label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.INGREDIENTS') },
  { id: 'recipes', label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.RECIPES') },
  { id: 'products', label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.PRODUCTS') },
  { id: 'categories', label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.CATEGORIES') },
  {
    id: 'subCategories',
    label: i18next.t('ADMIN.TRANSLATIONS.TRANSLATIONS_TABLE.ROWS.SUBCATEGORIES'),
  },
];

const LANGUAGE_TO_FLAG_COUNTRY = {
  en: 'GB',
};

export const getLanguageColumns = (languageCodes, options = {}) => {
  const { minWidth = 150 } = options;

  return languageCodes.map(({ id, code, name }) => {
    const countryCode = (LANGUAGE_TO_FLAG_COUNTRY[code?.toLowerCase()] ?? code)?.toUpperCase();
    const flagKey = countryCode.charAt(0) + countryCode.charAt(1).toLowerCase();
    const FlagComponent = Flags[flagKey];

    return {
      id: id,
      name: FlagComponent ? (
        <>
          <FlagComponent /> {name}
        </>
      ) : (
        name
      ),
      propertyKey: id,
      disableSort: true,
      minWidth,
      large: true,
    };
  });
};
